export function SignWaitZero2Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M2.66683 7.99998C2.66683 5.05446 5.05464 2.66665 8.00016 2.66665C10.9457 2.66665 13.3335 5.05446 13.3335 7.99998C13.3335 10.9455 10.9457 13.3333 8.00016 13.3333C5.05464 13.3333 2.66683 10.9455 2.66683 7.99998ZM8.00016 1.33331C4.31826 1.33331 1.3335 4.31808 1.3335 7.99998C1.3335 11.6819 4.31826 14.6666 8.00016 14.6666C11.6821 14.6666 14.6668 11.6819 14.6668 7.99998C14.6668 4.31808 11.6821 1.33331 8.00016 1.33331ZM8.66683 4.66665C8.66683 4.29846 8.36835 3.99998 8.00016 3.99998C7.63197 3.99998 7.3335 4.29846 7.3335 4.66665V8.27612L9.52876 10.4714C9.78911 10.7317 10.2112 10.7317 10.4716 10.4714C10.7319 10.211 10.7319 9.78892 10.4716 9.52858L8.66683 7.72384V4.66665Z"
        fill="currentColor"
      />
    </svg>
  );
}
